import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[aswVerticalSlidePer]',
})
export class VerticalSlidePerDirective {
  /** 行方向のずれ（%） */
  @Input() set aswVerticalSlidePer(perNum: number | undefined) {
    if (!!perNum && perNum !== 0) {
      const element = this.elementRef.nativeElement as HTMLElement;
      const style = element.style;
      const seatHeight = element.offsetHeight;
      const changePx = `${(perNum / 100) * seatHeight}px`;
      style.top = changePx;
    }
  }

  constructor(private elementRef: ElementRef) {}
}
